<template>
    <div class="section">
        <div class="container-fluid">
            <div class="">
                <div class="container ">
                    <div class="columns" style="padding-top: 50px;">
                        <div class="column is-5-desktop">
                            <h1 class="title has-text-centered">Create Transaction</h1>
                            <transition name="fade">
                                <div v-if="alertMessage" class="alert-message is-success has-text-centered">
                                    {{ alertMessage }}
                                </div>
                            </transition>
                            <form>
                                <div class="field select-client-field">
                                    <div class="control">
                                        <model-select :options="options"
                                                      v-model="user"

                                                      class="input"
                                                      placeholder="Select Client">
                                        </model-select>
                                        <button @click.prevent="getInvoices" class="button is-primary">Get Invoices</button>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <input v-model="amount"
                                               v-bind:class=""
                                               class="input"
                                               type="number"
                                               placeholder="Amount"
                                               required=""
                                               autofocus="">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <datetime
                                                input-class="input"
                                                v-model="transactionDate"
                                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                type="date"
                                                value-zone="local"
                                                zone="local"
                                                placeholder="Select date"
                                        ></datetime>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <textarea v-model="description" class="textarea" placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="field">
                                    <div class="control text-center">
                                        <a v-if="amount - getAmountUsed >= 0" @click.prevent="createTransaction" class="button is-primary">Submit</a>
                                        <router-link
                                                tag="button"
                                                to="/banking"
                                                class="button is-danger">
                                            <span>Cancel</span>
                                        </router-link>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="column is-offset-2-desktop">
                            <div v-if="amount - getAmountUsed < 0" class="error-alert">&nbsp;
                                The amount entered for individual invoice(s) exceeds the total payment the customer has made. Please check and retry.
                            </div>
                            <h1 v-else class="title has-text-centered">&nbsp;</h1>
                            <div class="client-amount-table-container">
                                <div class="card">
                                    <div class="card-content">
                                        <table class="table table-striped client-amount-table">
                                            <tr>
                                                <th colspan="5" class="">Deposits</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.deposit | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Receivables</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.receivables | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount received</th>
                                                <th>{{ getCurrency }}{{ amount | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount used for payments</th>
                                                <th>{{ getCurrency }}{{ getAmountUsed | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount in Excess</th>
                                                <th>{{ getCurrency }}{{ amount - getAmountUsed |
                                                    formatNumber }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount refunded</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.moneyOut | formatNumber }}</th>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="invoice-heading">
                                <h1 class="title has-text-centered">Unpaid Invoices</h1>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th class="invoice_id"><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th class="issued_date"><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th class="chassis"><span @click="setOrder('manager_id')" class="link">Chassis</span></th>
                                        <th class="due_amount"><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th class="used_amount"><span @click="setOrder('manager_id')" class="link">Used Amount</span></th>
                                        <th class="deposit"><span @click="setOrder('manager_id')" class="link">Deposit</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <unpaid-invoice-table-row v-for="(invoice, index) in unpaidInvoices"
                                                              :invoice="invoice" :invoiceDeposit="invoice.deposit" :invoiceAmountUsed="invoice.amount_used" :action="'add'" :transactionTotals="transactionTotals" :amount="amount"></unpaid-invoice-table-row>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="column">
                            <div class="invoice-heading">
                                <h1 class="title has-text-centered">Unpaid Multi Invoices</h1>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th class="invoice_id"><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th class="issued_date"><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th class="due_amount"><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th class="deposit"><span @click="setOrder('manager_id')" class="link">Deposit</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                        <unpaid-multi-invoice-table-tr v-for="(multi_invoice, index) in unpaidMultiInvoices" :multiInvoice="multi_invoice" :transactionTotals="transactionTotals"></unpaid-multi-invoice-table-tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <unpaid-multi-invoices-modal :amount="amount"></unpaid-multi-invoices-modal>
    </div>
</template>

<script>
    import {ModelSelect} from 'vue-search-select'
    import apiUsers from './../../api/apiUsers'
    import {Datetime} from 'vue-datetime'
    import UnpaidInvoiceTableRow from "./UnpaidInvoiceTableRow";
    import apiProformaInvoices from "../../api/apiProformaInvoices";
    import UnpaidMultiInvoiceTableRow from "./UnpaidMultiInvoiceTableRow";
    import UnpaidMultiInvoiceTableTr from "./UnpaidMultiInvoiceTableTr";
    import UnpaidMultiInvoicesModal from "./UnpaidMultiInvoicesModal";

    export default {
        components: {
            UnpaidMultiInvoicesModal,
            UnpaidMultiInvoiceTableTr,
            UnpaidMultiInvoiceTableRow,
            UnpaidInvoiceTableRow,
            ModelSelect,
            Datetime
        },
        data() {
            return {
                //unpaidInvoices: [],
                unpaidMultiInvoices: [],
                options: [],
                transactionDate: new Date().toISOString(),

                countries: [],
                professional: false,
                roles: [
                    'Visitor',
                    'User',
                    'Manager',
                    'Affiliate',
                    'Admin'
                ],
                isProfessional: false,
                amount: '',
                user: '',
                type: 1,
                description: '',
            }
        },
        computed: {
            success: function () {
                return this.$store.getters.getNewCarSuccessStatus
            },
            isLoading: function () {
                return this.$store.getters.getNewCarLoadingStatus
            },
            userId: function () {
                return this.$store.getters.getNewCarUser
            },
            alertMessage: function () {
                return this.$store.getters.getTransactionStatus
            },
            transactionTotals: function () {
                return this.$store.getters.getTransactionTotals
            },
            getCurrency: function () {
                return this.$store.getters.getTransactionTotals.currency == 2 ? '$' : '¥'
            },
            getAmountUsed: function () {
                let invoiceAmountUsed = this.$store.getters.getInvoiceAmountUsed
                let used_amount = 0;
                invoiceAmountUsed.forEach((invObj) => {
                    used_amount += Number(invObj.amount_used)
                })

                return used_amount
            },
            unpaidInvoices: function (){ return this.$store.getters.getUnpaidAllInvoices}
        },
        methods: {
            getInvoices(){
                apiProformaInvoices
                    .requestUnpaidInvoices(this.user)
                    .then((response) => {
                        this.$store.commit('setUnpaidAllInvoices', response.data.invoices)
                        //this.unpaidInvoices = this.$store.getters.getUnpaidAllInvoices
                        this.unpaidMultiInvoices = response.data.multi_invoices;
                    })
                this.$store.dispatch('getTransactionTotals', this.user)
            },
            setSelectOptions(users) {
                let list = []

                users.forEach(function (element) {
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })

                this.options = list
            },
            createTransaction(){
                let invoices = this.$store.getters.getInvoiceAmountUsed
                //let multiInvoices = this.$store.getters.getMultiInvoiceAmountUsed
                let data = {
                    client_id: this.user,
                    amount: this.amount,
                    type: this.type,
                    transaction_date: this.transactionDate,
                    description: this.description,
                    invoices: invoices,
                    //multi_invoices: multiInvoices
                }
                this.$store.dispatch('createBankingTransaction', data)
                setTimeout(() => {
                    this.$router.push('/banking');
                })
                this.amount = '';
                this.transactionDate = new Date().toISOString();
                this.description = '';
            },
            getTotalDueAmount(){
                let totalDue = 0;
                this.unpaidInvoices.forEach((invoice, index) => {
                    if(invoice.currency == 2 && this.transactionTotals.currency != 2){
                        totalDue += Math.round(invoice.balance_due * invoice.rate) - invoice.paid_amount;
                    }else{
                        totalDue += invoice.balance_due - invoice.paid_amount;
                    }
                })
                return totalDue;
            },
            getTotalPaidAmount(){
                let totalPaid = 0;
                this.unpaidInvoices.forEach((invoice, index) => {
                    totalPaid = invoice.paid_amount;
                });
                return totalPaid;
            }
        },
        created() {
            this.$store.commit("setUnpaidAllInvoices", {}); // Empty unpaid all invoices

            this.$store.dispatch('setNewCarErrorsToDefault')
            this.$store.commit('setTransactionStatus', '')
            this.$store.commit('resetInvoiceAmountUsed')
            this.$store.commit('setTransactionTotals', {
                moneyIn: 0,
                moneyOut: 0,
                payment: 0,
                subTotal: 0,
                currency: 1
            })

            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>

    .field.select-client-field .control {
        display: flex;
    }

    .field.select-client-field .control button.button.is-primary {
        margin-left: 10px;
        align-self: center;
    }
    .alert-message {
        margin-bottom: 10px;
    }
    table.table.client-amount-table {
        width: 100%;
    }
    .error-alert {
        background-color: #ffecec;
        color: #b94a48;
        padding: 5px 10px;
        border: 1px solid #ffdde2;
        border-radius: 5px;
        margin-bottom: 10px;
    }


</style>



// WEBPACK FOOTER //
// src/components/Banking/CreateTransaction.vue